// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-02T10:37:54Z                      #

// ##############################################################


/**
 * Vedoucí - přehled.
 */
export const POP_PAROVANI_PLATEB = 'POP_PAROVANI_PLATEB';

/**
 * Oprávnění na kategorie POP
 */
export const POP_KATEGORIE = 'POP_KATEGORIE';

/**
 * Seznam všech hodnot.
 */
export const values = [
    POP_PAROVANI_PLATEB,
    POP_KATEGORIE
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [POP_PAROVANI_PLATEB]: {caption: 'Vedoucí - přehled.'},
    [POP_KATEGORIE]: {caption: 'Oprávnění na kategorie POP'}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}